import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function regions() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            active: true
        };

        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`region/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`region/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('region/create', data);
    }

    function update(data) {
        return axiosInstance.patch('region/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`region/delete`, {
            data: {
                id: id
            }
        });
    }
}
